import { createContext } from "react";

export const TOKEN_KEY = "auth_token";
export const USER_CPF_KEY = "user_cpf";
export const USER_IS_ADM = "user_is_adm";
export const INDUSTRIAL_LINKED_UNITS = "ind_linked_units";

export const AuthService = {
  getTokenLocalStorage: () => {
    try {
      return localStorage.getItem(TOKEN_KEY);
    } catch {
      return null;
    }
  },
  getUserCpfLocalStorage: () => {
    try {
      return localStorage.getItem(USER_CPF_KEY);
    } catch {
      return null;
    }
  },

  getAdmLocalStorage: () => {
    try {
      return localStorage.getItem(USER_IS_ADM) === "true";
    } catch {
      return false;
    }
  },

  setTokenLocalStorage: (token) => {
    localStorage.setItem(TOKEN_KEY, token);
  },

  setUserCpfLocalStorage: (cpf) => {
    localStorage.setItem(USER_CPF_KEY, cpf);
  },

  removeTokenLocalStorage: () => {
    localStorage.removeItem(TOKEN_KEY);
  },

  removeUserCpfLocalStorage: () => {
    localStorage.removeItem(USER_CPF_KEY);
  },

  setIsAdmLocalStorage: (isAdm) => {
    localStorage.setItem(USER_IS_ADM, isAdm);
  },

  removeIsAdmLocalStorage: () => {
    localStorage.removeItem(USER_IS_ADM);
  },

  getIndustrialLinkedUnits: () => {
    try {
      const raw = localStorage.getItem(INDUSTRIAL_LINKED_UNITS);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  },
  setIndustrialLinkedUnits: (linkedUnits) => {
    localStorage.setItem(
      INDUSTRIAL_LINKED_UNITS,
      JSON.stringify(linkedUnits ?? null)
    );
  },

  removeIndustrialLinkedUnits: () => {
    localStorage.removeItem(INDUSTRIAL_LINKED_UNITS);
  },
};

const AuthContext = createContext();

export default AuthContext;
